import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
const SvgMaterialSymbolsFastForward = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path fill="currentColor" d="M2.5 18V6l9 6zm10 0V6l9 6z" />
  </svg>
);
const ForwardRef = forwardRef(SvgMaterialSymbolsFastForward);
const Memo = memo(ForwardRef);
export default Memo;
